export default __webpack_public_path__ + "static/media/rw_data_feedback.1edd1c6a.png";